import * as yup from "yup";

import { recaptcha } from "@/utils/validation/schemas/general.RHF";
import * as RHFGiftcardValidationRules from "@/utils/validation/schemas/giftCard.RHF";

export const GiftCardRequestBalanceFormValidationSchema = yup.object({
    giftCardNumber: RHFGiftcardValidationRules.giftCard,
    recaptcha: recaptcha
});

export type GiftCardRequestBalanceFormValues = yup.InferType<
    typeof GiftCardRequestBalanceFormValidationSchema
>;
